<template>

    <div class="flex flex-col w-full pb-20">

        <flash-message :position="'right bottom'" style="z-index: 999999999;" class="p-6"></flash-message>

        <!-- BEGIN PROCESSING MODAL COVER -->
        <div v-if="isUpdating" id="modal-cover" class="absolute w-full h-full top-0 left-0" style="z-index: 9999999; background-color: rgba(7,22,29,0.8);">
        <!--<div v-if="false" id="modal-cover" class="absolute w-full h-full top-0 left-0" style="z-index: 9999999; background-color: rgba(7,22,29,0.8);">-->
            <div class="w-full h-full flex items-center justify-center">
                <span class="text-theme-main text-lg font-bold leading-normal" style="transform: translate(-35%,0);">{{ translate('content-edit-processing') }}</span>
            </div>
            <div class="absolute frosted-glass w-full h-full top-0 left-0 opacity-75"></div>
        </div>
        <!-- END PROCESSING MODAL COVER -->

        <div id="sectionHeader" class="p-4 md:p-6 border-b border-theme-level2 items-center justify-between w-full">
            <h2 class="text-theme-discrete font-bold text-base md:text-xl">{{ translate("content-edit-title-1") }}<span v-if="theContent.legacy" class="text-theme-discrete font-bold text-base md:text-xl"> - {{ translate("legacy") }}</span>
                <span class="text-red-700" @click="getServerDateTime">{{translate("content-create-title-2") }}</span>
                <span class="text-sm text-theme-xmuted font-normal opacity-0">Server Time @ Page Load: {{ serverDateTime }}</span></h2>
        </div>

        <!-- BEGIN Fields Section -->
        <!--<div v-if="hasFinishedUpload" class="pb-4">-->
        <div v-if="true" class="pb-4">

            <div id="content-id-section" class="flex flex-row justify-between p-4 md:p-6 border-b border-theme-level2 w-full h-16 bg-theme-level3">

                <h2 class="text-theme-discrete font-bold text-base md:text-xl">{{ translate("content-create-editing-for") }} <span class="text-lg font-normal text-theme-main">{{ theContent.filename }} <span class="text-theme-xmuted">- DB ID: {{ theContent.id }}</span></span></h2>

                <div id="contentId" class="flex flex-row items-center relative">

                    <i class="material-icons ml-4 pl-2 pt-2 w-10 h-10 text-theme-discrete">insert_photo</i>
                    <span class="text-theme-discrete" v-text="thumbnail_state"></span>
                    <div class="thumbnailhovertrigger">
                        <img v-if="!cloudIsProcessing && !theContent.legacy && !changeMainThumbnail" class="h-10 ml-6" :src="cloudSource + mainThumbnailPreviewURL" alt="Thumbnail" />
                        <img v-if="changeMainThumbnail && hasFinishedUploadingMainThumbnail" class="h-10 ml-6" :src="mainThumbnailPreviewURL" alt="Thumbnail" />
                        <img v-if="!theContent.legacy && !theContent.thumbnail_url" class="h-10 ml-6" src="/images/waiting_thumbnail.png" alt="Thumbnail" />
                        <div v-if="!cloudIsProcessing && !theContent.legacy" id="fullsizethumbnail" class="thumbnailhovertarget absolute transition-all duration-100" style="right: 78px; width: 520px; top: -125px">
                            <img :src="cloudSource + theContent.thumbnail_url" alt="Thumbnail" />
                        </div>
                        <div v-if="changeMainThumbnail && hasFinishedUploadingMainThumbnail" id="fullsizethumbnail2" class="thumbnailhovertarget absolute transition-all duration-100" style="right: 78px; width: 520px; top: -125px">
                            <img :src="mainThumbnailPreviewURL" alt="Thumbnail" />
                        </div>
                    </div>

                </div>

                <div id="contentId2" class="flex flex-row items-center relative">

                    <button v-if="!changeMainThumbnail && !hasFinishedUploadingMainThumbnail"
                            class="flex flex-row items-center justify-center text-sm bg-theme-controls3 hover:bg-theme-controls2 text-theme-control-label rounded-lg px-4 w-32 h-10 ml-4 mr-6"
                            @click="changeMainThumbnail=true;thumbnail_state='...';">
                        {{ translate("content-edit-change") }}
                    </button>

                    <input v-if="changeMainThumbnail" type="file" accept="image/x-png,image/jpeg" class="text-theme-main ml-6 mr-6" ref="heroThumbInputControl" id="mainthumbpick" @change="processMainThumbnail($event.target.files)" />
                    <button v-if="changeMainThumbnail && mainThumbnailPreviewURL && !hasFinishedUploadingMainThumbnail"
                            class="flex flex-row items-center justify-center text-sm bg-theme-controls3 hover:bg-theme-controls2 text-theme-control-label rounded-lg px-4 w-64 h-10 ml-4 mr-6"
                            @click="uploadMainThumbnail">
                        <i class="material-icons w-6 h-6 mr-2 text-theme-control-label" style="font-size: 22px;">backup</i>
                        <!--{{ translate("content-edit-upload") }}-->
                    </button>
                    <progress-bar v-if="isUploadingMainThumbnail" size="small"
                                  :text="mainThumbnailUploadProgressText" :val="mainThumbnailUploadProgress"
                                  class="w-2/4 mt-6 text-sm text-theme-muted"></progress-bar>
                    <div v-else class="w-2/4 text-sm text-theme-muted ml-6" v-text="mainThumbnailUploadProgressText"></div>

                </div>

            </div>

            <!-- BEGIN DATA SECTION -->
            <div id="content-data-section" class="flex flex-col px-4 pt-4 pb-0 w-full text-sm">

                <div class="flex flex-row justify-between items-center mb-6">
                    <label for="fld-title" class="w-24 text-theme-muted mr-4 self-center">{{ translate('content-edit-title') }}:</label>
                    <div class="border-b border-theme-level2 flex-1 w-full">
                        <input type="text" v-model="theContent.title" id="fld-title" ref="titleField" maxlength="75"
                               name="title" class="appearance-none bg-theme-level4 border-none w-full text-theme-main mr-3 py-2 px-2 focus:outline-none" @change="isEditing=true" @input="isEditing=true" />
                    </div>
                    <span class="text-sm text-theme-muted self-end ml-4">{{ theContent.title.length }}/75 caract.</span>
                </div>

                <div class="flex flex-row justify-between items-center mb-6">
                    <label for="fld-abstract" class="relative w-24 text-theme-muted mr-4 self-start label-align-top">{{ translate('content-edit-abstract') }}:</label>
                    <div class="border-b border-theme-level2 flex-1 w-full">
                        <textarea-autosize v-model="theContent.abstract" id="fld-abstract" name="abstract" rows="1" ref="abstractField" maxlength="300"
                                           class="appearance-none bg-theme-level4 border-none w-full text-theme-main mr-3 py-1 px-2 focus:outline-none" style="line-height: 28px;"
                                           :placeholder="translate('content-edit-abstract-placeholder')" :min-height="28" :max-height="140" @input="checkForAreaChanges" />
                    </div>
                    <span class="text-sm text-theme-muted self-end ml-4">{{ theContent.abstract.length }}/300 caract.</span>
                </div>


                <div class="flex flex-row items-center mb-6">
                    <label for="fld-categories" class="w-24 text-theme-muted self-start">{{ translate('content-edit-categories') }}:</label>
                    <div class="w-4/5">
                        <ul id="fld-categories" class="flex flex-row flex-wrap">

                            <li v-if="currentlocale==='es'" v-for="(category, index) in JSON.parse(basecategories)" :key="category.name">
                                <!--suppress HtmlFormInputWithoutLabel -->
                                <input type="checkbox" v-model="newSelectedCategories"
                                       :value="category.id"
                                       class="form-checkbox h-5 w-5 text-theme-controls3 ml-4 mb-2 bg-theme-level5"
                                       :class="{ 'ml-4': index === 0}"
                                       checked
                                       @change="isEditing=true" >
                                <span class="ml-2 text-theme-discrete">{{ category.name }}</span>
                            </li>

                            <li v-if="currentlocale==='en'" v-for="(category, index) in JSON.parse(basecategories)" :key="category.name_en">
                                <!--suppress HtmlFormInputWithoutLabel -->
                                <input type="checkbox" v-model="newSelectedCategories"
                                       :value="category.id"
                                       class="form-checkbox h-5 w-5 text-theme-controls3 ml-4 mb-2 bg-theme-level5"
                                       :class="{ 'ml-4': index === 0}"
                                       checked
                                       @change="isEditing=true" >
                                <span class="ml-2 text-theme-discrete">{{ category.name_en }}</span>
                            </li>

                        </ul>
                    </div>
                </div>



                <div class="flex flex-row items-center mb-6">
                    <label for="fld-subcategories" class="w-24 text-theme-muted self-start">{{ translate('content-edit-subcategories') }}:</label>
                    <div class="w-4/5">
                        <ul id="fld-subcategories" class="flex flex-row flex-wrap">

                            <li v-if="currentlocale==='es'" v-for="(subcategory, index) in JSON.parse(basesubcategories)" :key="subcategory.name">
                                <!--suppress HtmlFormInputWithoutLabel -->
                                <input type="checkbox" v-model="newSelectedSubCategories"
                                       :value="subcategory.id"
                                       class="form-checkbox h-5 w-5 text-theme-controls3 ml-4 mb-2 bg-theme-level5"
                                       :class="{ 'ml-4': index === 0}"
                                       checked
                                       @change="isEditing=true" >
                                <span class="ml-2 text-theme-discrete">{{ subcategory.name }}</span>
                            </li>

                            <li v-if="currentlocale==='en'" v-for="(subcategory, index) in JSON.parse(basesubcategories)" :key="subcategory.name_en">
                                <!--suppress HtmlFormInputWithoutLabel -->
                                <input type="checkbox" v-model="newSelectedSubCategories"
                                       :value="subcategory.id"
                                       class="form-checkbox h-5 w-5 text-theme-controls3 ml-4 mb-2 bg-theme-level5"
                                       :class="{ 'ml-4': index === 0}"
                                       checked
                                       @change="isEditing=true" >
                                <span class="ml-2 text-theme-discrete">{{ subcategory.name_en }}</span>
                            </li>

                        </ul>
                    </div>
                </div>



                <div class="flex flex-row items-center mb-6">

                    <label for="fld-tags" class="relative w-24 text-theme-muted self-start label-align-top">{{ translate('content-edit-tags') }}:</label>

                    <vue-tags-input id="fld-tags"
                                    v-model="tag" :tags="newSelectedTags" :autocomplete-items="filteredItems"
                                    :add-only-from-autocomplete="true"
                                    @tags-changed="newTags => newSelectedTags = newTags"
                                    @before-deleting-tag="tagEditing"
                                    @input="isEditing=true"
                                    class="tags-input ml-4 border-b border-theme-level2 w-full flex-1 bg-theme-level5" />

                </div>




                <div class="flex flex-row items-center" :class="{ 'mb-4': Array.isArray(selectedPoiArray) && selectedPoiArray.length, 'mb-6': !(Array.isArray(selectedPoiArray) && selectedPoiArray.length) }">
                    <label for="fld-persons" class="w-24 text-theme-muted mr-4">{{ translate('content-edit-persons') }}:</label>
                    <div class="py-1 w-1/5">
                        <v-select id="fld-persons"
                                  class="bg-theme-level5 text-theme-main"
                                  :clearable="false" :placeholder="translate('content-edit-open-persons')"
                                  :options="personsList" @input="personSelected"></v-select>
                    </div>
                </div>
                <div v-if="Array.isArray(newSelectedPoiArray) && newSelectedPoiArray.length" id="radios-group" v-model="newSelectedPoiArray" class="mb-2">
                    <div v-model="newSelectedPoiArray" v-for="(person, index) in newSelectedPoiArray" class="flex flex-row items-center mb-4">
                        <div class="w-24 mr-4"></div>
                        <div class="w-1/5 border-b border-theme-level2 text-theme-discrete mr-4">{{ person.label }}</div>
                        <i class="material-icons ml-2 mr-4 cursor-pointer w-6 h-6 text-theme-muted hover:text-theme-main" @click="removePoiFromSelectedList(index)">delete</i>
                        <!--suppress HtmlFormInputWithoutLabel -->
                        <!--<input type="checkbox" class="form-checkbox h-5 w-5 text-theme-controls3"><span class="ml-2 text-theme-discrete">Marcar como Corresponsal</span>-->
                        <input v-if="person.correspondent===1"
                               type="radio" name="selectedCorrespondent"
                               class="form-radio h-5 w-5 text-theme-controls3"
                               :value="person.id" v-model="assignedCorrespondent" @change="isEditing=true">
                        <span v-if="person.correspondent===1" class="ml-2 text-theme-discrete">{{ translate('content-edit-mark-correspondent') }}</span>
                    </div>
                </div>








                <div class="flex flex-row items-center" :class="{ 'mb-4': Array.isArray(selectedCountriesArray) && selectedCountriesArray.length, 'mb-6': !(Array.isArray(selectedCountriesArray) && selectedCountriesArray.length) }">
                    <label for="fld-persons" class="w-24 text-theme-muted mr-4">{{ translate('content-edit-countries') }}:</label>
                    <div class="py-1 w-1/5">
                        <v-select id="fld-countries"
                                  class="bg-theme-level5 text-theme-main"
                                  :clearable="false" :placeholder="translate('content-edit-open-countries')"
                                  :options="countriesList" @input="countrySelected"></v-select>
                    </div>
                </div>
                <div v-if="Array.isArray(newSelectedCountryArray) && newSelectedCountryArray.length" id="country-radios-group" v-model="newSelectedCountryArray" class="mb-2">
                    <div v-model="newSelectedCountryArray" v-for="(country, index) in newSelectedCountryArray" class="flex flex-row items-center mb-4">
                        <div class="w-24 mr-4"></div>
                        <div class="w-1/5 border-b border-theme-level2 text-theme-discrete mr-4">{{ country.label }}</div>
                        <i class="material-icons ml-2 mr-4 cursor-pointer w-6 h-6 text-theme-muted hover:text-theme-main" @click="removeCountryFromSelectedList(index)">delete</i>
                    </div>
                </div>


                <div class="flex flex-row items-center mb-6 w-full">

                    <label for="fld-publish" class="w-24 text-theme-muted mr-4">{{ translate('content-edit-publish') }}:</label>
                    <div class="py-1 w-1/5">
                        <v-select id="fld-publish" v-model="publishActionId"
                                  :clearable="false" :placeholder="translate('content-edit-publish-when')"
                                  class="bg-theme-level5 text-theme-main text-sm"
                                  :value="publishActionId"
                                  :options="[
                                      { label: translate('content-edit-publish-immediately'), id: 0 },
                                      { label: translate('content-edit-publish-schedule'), id: 1 }
                                      ]" @input="publishHasChanged"
                                  @change="updatePublishDate">
                        </v-select>
                    </div>

                    <div v-if="displayDateTimePicker" class="relative ml-2 flex flex-row items-center">
                        <v-date-picker
                            v-model="pickedPublishingDate"
                            :min-date='new Date()'
                            :popover="{ placement: 'bottom', visibility: 'click' }"
                            @input="updatePublishDate">
                            <button class="p-2 bg-theme-controls3 hover:bg-theme-controls2 text-theme-control-label rounded focus:outline-none">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                    class="w-4 h-4 fill-current">
                                    <path d="M1 4c0-1.1.9-2 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4zm2 2v12h14V6H3zm2-6h2v2H5V0zm8 0h2v2h-2V0zM5 9h2v2H5V9zm0 4h2v2H5v-2zm4-4h2v2H9V9zm0 4h2v2H9v-2zm4-4h2v2h-2V9zm0 4h2v2h-2v-2z" />
                                </svg>
                            </button>
                        </v-date-picker>
                        <button class="p-1 ml-1 bg-theme-controls3 hover:bg-theme-controls2 text-theme-control-label rounded focus:outline-none">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                class="w-4 h-4 fill-current"
                                style="height: 1.5rem; width: 1.5rem;"
                                @click="toggleTimePicker">
                                <g><rect fill="none" height="24" width="24"/></g>
                                <g><g><polygon points="10,8 10,14 14.7,16.9 15.5,15.7 11.5,13.3 11.5,8"/><path d="M17.92,12c0.05,0.33,0.08,0.66,0.08,1c0,3.9-3.1,7-7,7s-7-3.1-7-7c0-3.9,3.1-7,7-7c0.7,0,1.37,0.1,2,0.29V4.23 C12.36,4.08,11.69,4,11,4c-5,0-9,4-9,9s4,9,9,9s9-4,9-9c0-0.34-0.02-0.67-0.06-1H17.92z"/><polygon points="20,5 20,2 18,2 18,5 15,5 15,7 18,7 18,10 20,10 20,7 23,7 23,5"/></g></g>
                            </svg>
                        </button>
                        <div v-if="timePickerVisible" class="ml-1">
                            <vue-timepicker
                                close-on-complete
                                auto-scroll
                                hide-clear-button
                                input-width="100px"
                                :minute-interval="15"
                                @change="handleTimePicked"
                                v-model="simpleStringValue"></vue-timepicker>
                        </div>
                    </div>

                    <label for="fld-visibility" class="w-20 text-theme-muted ml-6">{{ translate('content-edit-visibility') }}:</label>
                    <div class="py-1 w-1/5">
                        <v-select id="fld-visibility" v-model="contentVisibility"
                                  :clearable="false" :placeholder="translate('content-edit-who-can-see')"
                                  class="bg-theme-level5 text-theme-main"
                                  @input="updateVisibility"
                                  :options="[
                                      { label: this.translate('content-edit-public'), id: 1 },
                                      { label: this.translate('content-edit-private'), id: 2 },
                                      { label: this.translate('content-edit-unlisted'), id: 3 }
                                      ]"></v-select>
                    </div>

                    <label for="fld-restrictions" class="w-20 text-theme-muted mr-4 ml-6">{{ translate('content-edit-restrictions') }}:</label>
                    <div class="py-1 w-1/5">
                        <v-select id="fld-restrictions" v-model="contentRestrictions"
                                  :clearable="false" :placeholder="translate('content-edit-who-can-download')"
                                  class="bg-theme-level5 text-theme-main"
                                  @input="updateRestrictions"
                                  :options="[
                                      { label: this.translate('content-edit-open'), id: 1 },
                                      { label: this.translate('content-edit-credentials'), id: 2 },
                                      { label: this.translate('content-edit-restricted'), id: 3 }
                                      ]"></v-select>
                    </div>



                </div>

                <div v-if="scheduledPublishingDate !== ''" class="relative mt-0 flex flex-row items-center" style="top: -20px;">
                    <div class="w-24 mr-4"></div>
                    <div><span class="text-sm text-theme-muted">{{ translate('content-edit-scheduled-for') }}: {{ scheduledPublishingDate }} {{ scheduledPublishingTime}}</span></div>
                </div>

                <div class="flex flex-row items-center mb-2 w-full">
                    <!--suppress XmlInvalidId -->
                    <label for="fld-module-size" class="w-24 text-theme-muted mr-4">{{ translate('content-edit-module') }}</label>
                    <!--<label for="fld-module-size" class="w-20 text-theme-muted ml-6">Visibilidad:</label>-->
                    <div class="py-1 w-1/5">
                        <input v-if="currentlocale==='es'" type="radio" name="selectedModuleSize" class="form-radio h-5 w-5 text-theme-controls3 bg-theme-level5" :checked="incomingRenderSize==='Pequeño'" @click="renderSize='Pequeño'" @change="isEditing=true">
                        <input v-else type="radio" name="selectedModuleSize" class="form-radio h-5 w-5 text-theme-controls3 bg-theme-level5" :checked="incomingRenderSize==='Small'" @click="renderSize='Small'" @change="isEditing=true">
                        <span class="ml-2 text-theme-discrete mr-4">{{ translate('content-edit-module-small') }}</span>
                        <input v-if="currentlocale==='es'" type="radio" name="selectedModuleSize" class="form-radio h-5 w-5 text-theme-controls3 bg-theme-level5" :checked="incomingRenderSize==='Grande'" @click="renderSize='Grande'" @change="isEditing=true">
                        <input v-else type="radio" name="selectedModuleSize" class="form-radio h-5 w-5 text-theme-controls3 bg-theme-level5" :checked="incomingRenderSize==='Large'" @click="renderSize='Large'" @change="isEditing=true">
                        <span class="ml-2 text-theme-discrete">{{ translate('content-edit-module-large') }}</span>
                    </div>
                </div>







                <div class="flex flex-row items-center mb-2 mt-4 w-full">
                    <!--suppress XmlInvalidId -->
                    <label for="fld-hero" class="w-24 text-theme-muted mr-4">{{ translate("hero-content") }}:</label>
                    <!--suppress HtmlFormInputWithoutLabel -->
                    <input type="checkbox" v-model="isHeroContent"
                           :value="false"
                           class="form-checkbox h-5 w-5 text-theme-controls3 mb-2 bg-theme-level5"
                           @input="heroContentSelected" />
                    <span class="ml-2 text-theme-discrete">{{ translate("hero-content-label") }}</span>
                </div>

                <div v-if="heroContentSectionVisible" class="flex flex-col items-center mb-2 mt-4 w-full">

                    <div class="flex flex-row items-center mb-2 w-full">
                        <label for="thumbpick" class="w-24 text-theme-muted mr-4">{{ translate("hero-content-thumbnail") }}:</label>
                        <img :src="this.heroThumbnailPreviewURL" alt="" style="width: 80px;">
                        <button v-if="!changeHeroThumbnail && !hasFinishedUploadingThumbnail"
                                class="flex flex-row items-center justify-center text-sm bg-theme-controls3 hover:bg-theme-controls2 text-theme-control-label rounded-lg px-4 w-64 h-10 ml-4 mr-6"
                                @click="changeHeroThumbnail=true">
                            {{ translate("content-edit-change") }}
                        </button>
                        <input v-if="changeHeroThumbnail" type="file" accept="image/x-png,image/jpeg" class="text-theme-main ml-6 mr-6" ref="heroThumbInputControl" id="thumbpick" @change="processHeroThumbnail($event.target.files)" />
                        <button v-if="changeHeroThumbnail && heroThumbnailPreviewURL && !hasFinishedUploadingThumbnail"
                                class="flex flex-row items-center justify-center text-sm bg-theme-controls3 hover:bg-theme-controls2 text-theme-control-label rounded-lg px-4 w-64 h-10 ml-4 mr-6"
                                @click="uploadThumbnail">
                            <i class="material-icons w-6 h-6 mr-2 text-theme-control-label" style="font-size: 22px;">backup</i>
                            {{ translate("content-edit-upload") }}
                        </button>
                        <progress-bar v-if="isUploadingThumbnail" size="small"
                                      :text="thumbnailUploadProgressText" :val="thumbnailUploadProgress"
                                      class="w-2/4 mt-6 text-sm text-theme-muted"></progress-bar>
                        <div v-else class="w-2/4 text-sm text-theme-muted ml-6" v-text="thumbnailUploadProgressText"></div>
                        <!--<input type="file" accept="image/x-png,image/jpeg" class="text-theme-main" ref="heroThumbInputControl" id="thumbpick" @change="processHeroThumbnail($event.target.files)" />-->
                    </div>
                    <p class="text-xs text-theme-discrete self-start ml-32" v-text="this.theContent.hero_thumbnail"></p>

                    <div class="flex flex-row items-center mb-2 mt-4 w-full">
                        <!--suppress XmlInvalidId -->
                        <label for="bkgpick" class="w-24 text-theme-muted mr-4">{{ translate("hero-content-background") }}:</label>
                        <!--suppress HtmlFormInputWithoutLabel -->
                        <input type="radio" name="selectedBackground" class="form-radio h-5 w-5 text-theme-controls3" :value="0" v-model="heroContentAssignedBkg" @input="heroContentCustomBkg=false; isEditing=true;"><span class="ml-2 text-theme-discrete">{{ translate("hero-content-background") }} A</span>
                        <!--suppress HtmlFormInputWithoutLabel -->
                        <input type="radio" name="selectedBackground" class="ml-6 form-radio h-5 w-5 text-theme-controls3" :value="1" v-model="heroContentAssignedBkg" @input="heroContentCustomBkg=false; isEditing=true;"><span class="ml-2 text-theme-discrete">{{ translate("hero-content-background") }} B</span>
                        <!--suppress HtmlFormInputWithoutLabel -->
                        <input type="radio" name="selectedBackground" class="ml-6 form-radio h-5 w-5 text-theme-controls3" :value="2" v-model="heroContentAssignedBkg" @input="heroContentCustomBkg=false; isEditing=true;"><span class="ml-2 text-theme-discrete">{{ translate("hero-content-background") }} C</span>
                        <!--suppress HtmlFormInputWithoutLabel -->
                        <input type="radio" name="selectedBackground" class="ml-6 form-radio h-5 w-5 text-theme-controls3" :value="3" v-model="heroContentAssignedBkg" @input="heroContentCustomBkg=true; isEditing=true;"><span class="ml-2 text-theme-discrete">{{ translate("hero-content-custom-background") }}</span>
                    </div>

                    <div v-if="heroContentCustomBkg" class="flex flex-row items-center mb-2 mt-4 w-full">
                        <label for="bkgpick_light" class="w-24 text-theme-muted mr-4">{{ translate("hero-content-custom-background") }} Light:</label>
                        <img v-if="heroCustomBkgLightPreviewURL" :src="this.heroCustomBkgLightPreviewURL" alt="" style="width: 80px;" >
                        <button v-if="!changeHeroLightBkg && !hasFinishedUploadingLightBkg"
                                class="flex flex-row items-center justify-center text-sm bg-theme-controls3 hover:bg-theme-controls2 text-theme-control-label rounded-lg px-4 w-64 h-10 ml-4 mr-6"
                                @click="changeHeroLightBkg=true">
                            {{ translate("content-edit-change") }}
                        </button>

                        <input v-if="changeHeroLightBkg" type="file" accept="image/x-png,image/jpeg" class="text-theme-main ml-6 mr-6" ref="heroThumbInputControl" id="lightbkgpick" @change="processHeroCustomLightBkg($event.target.files)" />
                        <button v-if="changeHeroLightBkg && heroCustomBkgLightPreviewURL && !hasFinishedUploadingLightBkg"
                                class="flex flex-row items-center justify-center text-sm bg-theme-controls3 hover:bg-theme-controls2 text-theme-control-label rounded-lg px-4 w-64 h-10 ml-4 mr-6"
                                @click="uploadLightBkg">
                            <i class="material-icons w-6 h-6 mr-2 text-theme-control-label" style="font-size: 22px;">backup</i>
                            {{ translate("content-edit-upload") }}
                        </button>
                        <progress-bar v-if="isUploadingLightBkg" size="small"
                                      :text="lightBkgUploadProgressText" :val="lightBkgUploadProgress"
                                      class="w-2/4 mt-6 text-sm text-theme-muted"></progress-bar>
                        <div v-else class="w-2/4 text-sm text-theme-muted ml-6" v-text="lightBkgUploadProgressText"></div>

                        <!--<input type="file" accept="image/x-png,image/jpeg" class="text-theme-main" ref="heroBkgInputControlLight" id="bkgpick_light" @change="processHeroCustomLightBkg($event.target.files)" />-->
                    </div>

                    <div v-if="heroContentCustomBkg" class="flex flex-row items-center mb-2 mt-4 w-full">
                        <label for="bkgpick_dark" class="w-24 text-theme-muted mr-4">{{ translate("hero-content-custom-background") }} Dark:</label>
                        <img v-if="heroCustomBkgDarkPreviewURL" :src="this.heroCustomBkgDarkPreviewURL" alt="" style="width: 80px;">
                        <button v-if="!changeHeroDarkBkg && !hasFinishedUploadingDarkBkg"
                                class="flex flex-row items-center justify-center text-sm bg-theme-controls3 hover:bg-theme-controls2 text-theme-control-label rounded-lg px-4 w-64 h-10 ml-4 mr-6"
                                @click="changeHeroDarkBkg=true">
                            {{ translate("content-edit-change") }}
                        </button>

                        <input v-if="changeHeroDarkBkg" type="file" accept="image/x-png,image/jpeg" class="text-theme-main ml-6 mr-6" ref="heroThumbInputControl" id="darkbkgpick" @change="processHeroCustomDarkBkg($event.target.files)" />
                        <button v-if="changeHeroDarkBkg && heroCustomBkgDarkPreviewURL && !hasFinishedUploadingDarkBkg"
                                class="flex flex-row items-center justify-center text-sm bg-theme-controls3 hover:bg-theme-controls2 text-theme-control-label rounded-lg px-4 w-64 h-10 ml-4 mr-6"
                                @click="uploadDarkBkg">
                            <i class="material-icons w-6 h-6 mr-2 text-theme-control-label" style="font-size: 22px;">backup</i>
                            {{ translate("content-edit-upload") }}
                        </button>
                        <progress-bar v-if="isUploadingDarkBkg" size="small"
                                      :text="darkBkgUploadProgressText" :val="darkBkgUploadProgress"
                                      class="w-2/4 mt-6 text-sm text-theme-muted"></progress-bar>
                        <div v-else class="w-2/4 text-sm text-theme-muted ml-6" v-text="darkBkgUploadProgressText"></div>

                        <!--<input type="file" accept="image/x-png,image/jpeg" class="text-theme-main" ref="heroBkgInputControlDark" id="bkgpick_dark" @change="processHeroCustomDarkBkg($event.target.files)" />-->
                    </div>

                    <div class="flex flex-row items-center mb-2 mt-4 w-full">

                        <label for="fld-hero-text" class="w-24 text-theme-muted mr-4">{{ translate("hero-content-description") }}:</label>
                        <input type="text" v-model="heroContentText" id="fld-hero-text" ref="heroTextField" maxlength="100"
                               name="herotext" class="appearance-none bg-theme-level4 border-none text-theme-main mr-3 py-2 px-2 focus:outline-none w-2/3"
                               @input="isEditing=true" />
                        <span class="text-sm text-theme-muted self-end ml-4">{{ heroContentText.length }}/100</span>
                        <!--<span v-else class="text-sm text-theme-muted self-end ml-4">0/100</span>-->

                    </div>

                </div>


            </div>
            <!-- END DATA SECTION -->

        </div>
        <!-- END Fields Section -->

        <hr />

        <div id="buttons-container" class="flex flex-row w-1/2 justify-start text-sm py-6 block items-center" style="display: block;">
            <button v-show="!isUpdating" class="bg-theme-controls-discrete hover:bg-theme-controls2 text-theme-control-label rounded-lg px-6 h-10 ml-6" @click="cancelEditing">{{ translate("cancel") }}</button>

            <button v-if="isEditing && readyToPublish" class="bg-theme-controls3 hover:bg-theme-controls2 text-theme-control-label rounded-lg px-6 h-10 ml-2" @click="updateContent">
                <div class="flex flex-row items-center">
                    <i class="absolute material-icons w-6 h-6 mr-2 text-theme-control-label">publish</i>
                    <span class="ml-8 mr-2">{{ translate("content-edit") }}</span>
                </div>
            </button>
            <button class="bg-theme-level3 text-theme-discrete rounded-lg px-6 h-10 ml-2 cursor-default" v-show="isEditing && !readyToPublish" disabled>{{ translate("content-edit-missing-data") }}</button>
        </div>

        <hr />

        <!-- BEGIN PREVIZ SECTION -->
        <div id="file-preview-section" class="flex flex-col p-4 md:p-6 w-full">

            <div v-if="heroContentSectionVisible" >

                <h2 class="text-theme-discrete mb-2 font-bold">{{ translate("content-edit-previz-hero") }}</h2>

                <div id="hero-preview-container" class="hero-section bg-theme-level4 mb-12"
                     :style="heroContentStyling">
                    <div style="min-width: 498px; max-width: 498px; min-height: 280px; max-height: 280px;">
                        <img :src="heroThumbnailPreviewURL" alt="" style="max-height: 280px;">
                    </div>
                    <div class="px-6 py-10 flex flex-col" style="min-height: 280px; max-height: 280px; min-width: 350px; max-width: 350px;">
                        <p class="text-theme-title text-lg leading-tight font-bold mb-2" v-text="theContent.title"></p>

                        <div class="flex-1" style="max-height: 20px;"></div>

                        <div class="">
                            <p v-if="heroContentText===''" class="text-xs text-theme-main leading-normal">{{ theContent.abstract.substring(0, 100) + '...' }}</p>
                            <p v-else class="text-xs text-theme-main leading-normal">{{ heroContentText }}</p>
                        </div>

                        <div class="flex-1"></div>

                        <span class="flex-1 pb-4 pt-4 text-xs text-theme-discrete flex flex-row items-center">
                            <i class="material-icons mr-2" style="font-size: 16px;">event_note</i>
                            <span class="flex-1">{{ translate("published-on") }} <span v-text="publishDatePart"></span>, {{ translate("at") }} <span v-text="publishTimePart"></span></span>
                            <i id="hero-module-options-button"
                               class="relative material-icons text-theme-muted hover:text-theme-discrete local-hover-target"
                               style="font-size: 26px;right: -10px;">more_vert</i>
                        </span>

                    </div>


                    <div class="moreSection invisible xl:visible flex flex-col" style="min-width: 300px;">

                        <div class="bg-theme-level2 text-sm p-8 text-theme-main mt-4 mb-2">Additional Content Area</div>
                        <div class="bg-theme-level2 text-sm p-8 text-theme-main mb-2">Additional Content Area</div>
                        <div class="bg-theme-level2 text-sm p-8 text-theme-main mb-4">Additional Content Area</div>

                    </div>

                </div>

            </div>



            <div id="preview-modules-container" class="flex flex-row" style="min-height: 650px;">

                <div id="small-previz" class="mr-6" style="min-width: 220px; max-width: 220px; min-height: 280px; max-height: 280px;">
                    <h2 class="text-theme-discrete mb-2 font-bold">{{ translate('content-edit-previz-small') }}</h2>
                    <div class="relative desktop-item shadow rounded-lg">

                        <img v-if="!theContent.legacy" :src="cloudSource + theContent.thumbnail_url" alt="" height="135" />
                        <img v-else src="/images/waiting_thumbnail.png" alt="" height="135" />

                        <p class="text-theme-main hover:text-theme-title pl-4 pr-4 pt-6 pb-4 leading-tight font-bold bg-theme-level4" v-text="theContent.title"></p>

                        <div class="flex-1 bg-theme-level4"></div>

                        <span class="px-4 pb-4 pt-2 text-xs text-theme-discrete flex flex-row items-center bg-theme-level4">
                            <i class="material-icons mr-2" style="font-size: 16px;">event_note</i>
                            <span class="flex-1"><span v-text="publishDatePart"></span>, <span v-text="publishTimePart"></span></span>
                            <!--<i id="module-options-button" class="relative material-icons cursor-pointer text-theme-muted hover:text-theme-discrete" style="font-size: 26px;right: -10px;">more_vert</i>-->
                        </span>

                        <div id="media-duration"
                             class="absolute bg-theme-dropdowndismissal w-24 h-8
                                    text-theme-control-label text-center pt-2 opacity-75
                                    border border-theme-control-label rounded-md"
                             style="top: 30%; right: 12px;" v-text="mediaDuration"></div>

                    </div>

                </div>

                <div id="large-previz" style="min-width: 440px; max-width: 440px; min-height: 570px; max-height: 570px;">

                    <h2 class="text-theme-discrete mb-2 font-bold">{{ translate('content-edit-previz-large') }}</h2>
                    <div class="relative desktop-large-item shadow flex flex-col h-full">

                        <img v-if="!theContent.legacy" :src="cloudSource + theContent.thumbnail_url" alt="" />
                        <img v-else src="/images/waiting_thumbnail.png" alt="" height="135" />

                        <p class="text-theme-main hover:text-theme-title px-6 pt-6 pb-4 text-xl leading-tight font-bold bg-theme-level4" v-text="theContent.title"></p>
                        <div id="abstract-text" class="w-full px-6 pt-1 pb-4 bg-theme-level4 leading-normal text-theme-discrete text-sm self-start" v-text="theContent.abstract">
                        </div>

                        <div id="flex-spacer" class="flex-1 bg-theme-level4 h-full"></div>

                        <span class="flex-1 px-6 pb-4 pt-4 text-base text-theme-discrete flex flex-row items-center bg-theme-level4">
                            <i class="material-icons mr-2" style="font-size: 16px;">event_note</i>
                            <span class="flex-1">{{ translate("published-on") }} <span v-text="publishDatePart"></span>, {{ translate("at") }} <span v-text="publishTimePart"></span></span>
                            <i id="module-options-button"
                               class="relative material-icons text-theme-muted hover:text-theme-discrete local-hover-target"
                               style="font-size: 26px;right: -10px;">more_vert</i>
                        </span>

                        <!-- BEGIN Module Controls -->
                        <div class="local-hover-target-secondary transform transition-all duration-200">

                        </div>
                        <!-- END Module Controls -->
                        <div id="large-media-duration"
                             class="absolute bg-theme-dropdowndismissal w-24 h-8
                                    text-theme-control-label text-center pt-2 opacity-75
                                    border border-theme-control-label rounded-md"
                             style="top: 38%; right: 12px;" v-text="mediaDuration"></div>
                    </div>

                </div>

            </div>
        </div>
        <!-- END PREVIZ SECTION -->





    </div>

</template>

<script>

    import HeroContentSection from "./HeroContentSection";
    import ProgressBar from 'vue-simple-progress';
    import VueTagsInput from '@johmun/vue-tags-input';
    import vSelect from 'vue-select';
    import VCalendar from 'v-calendar';
    import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'
    import moment from 'moment-timezone';

    // Styling for the Vue Select component
    import "vue-select/dist/vue-select.css";
    import 'vue2-timepicker/dist/VueTimepicker.css';

    const Lang = require('lang.js');
    import translations from './messages.js';

    const lang = new Lang();

    lang.setMessages(translations);

    export default {

        components: {
            HeroContentSection,
            VueTagsInput,
            ProgressBar,
            vSelect,
            VCalendar,
            VueTimepicker
        },

        data() {
            return {
                isEditing: false,
                isUpdating: false,

                theContent: '',

                cloudIsProcessing: false,
                thumbnail_state: this.translate('content-edit-thumbnail-selected'),

                changeMainThumbnail: false,
                mainThumbnailToUpload: null,
                mainThumbnailFileName: '',
                mainThumbnailPreviewURL: '',

                isUploadingMainThumbnail: false,
                mainThumbnailUploadProgress: 0,
                hasFinishedUploadingMainThumbnail: false,

                initialAreaText: '',

                newSelectedCategories: [],
                newSelectedSubCategories: [],
                newSelectedTags: [],
                newSelectedPoiArray: [],
                newSelectedCountryArray: [],

                tag: '',

                displayDateTimePicker: false,
                pickedPublishingDate: '',

                // For the Time Picker
                timePickerVisible: false,
                simpleStringValue: '00:00',

                assignedCorrespondent: JSON.parse(this.content).correspondent_id,

                contentVisibility: JSON.parse(this.content).visibility,
                contentRestrictions: JSON.parse(this.content).restrictions,

                scheduledPublishingDate: moment(JSON.parse(this.content).publish_date).format('YYYY-MM-DD HH:mm').split(' ')[0],
                scheduledPublishingTime: moment(JSON.parse(this.content).publish_date).format('YYYY-MM-DD HH:mm').split(' ')[1],
                publishDatePart: this.scheduledPublishingDate,
                publishTimePart: this.scheduledPublishingTime,

                visibilityIndex: '',
                restrictionsIndex: '',

                serverDateTime: '',

                publishActionId: 0,

                renderSize: this.content.render_size === 'Grande' ? '2' : '1',

                mediaDuration: JSON.parse(this.content).media_duration,

                /*ENV_CloudFront_Legacy_DNS_Name: 'https://telesur-vod-legacy-assets.s3.amazonaws.com/',
                ENV_CloudFront_DNS_Name: 'https://telesur-vod-streaming-assets.s3.amazonaws.com/'*/

                ENV_CloudFront_Legacy_DNS_Name: process.env.MIX_LEGACY_CLOUDFRONT_DNSNAME,
                ENV_CloudFront_DNS_Name: process.env.MIX_CLOUDFRONT_DNSNAME,
                ENV_CloudFront_LegacyThumbnails_DNS_Name: process.env.MIX_LEGACY_THUMBNAILS_CLOUDFRONT_DNSNAME,
                ENV_Thumbnail_Key: process.env.MIX_BASE_THUMBNAIL_KEY,

                uploadError: '',

                isHeroContent: JSON.parse(this.content).is_hero,

                heroContentSectionVisible: JSON.parse(this.content).is_hero,
                heroContentAssignedBkg: JSON.parse(this.content).hero_background,

                /*incomingHeroThumbnail: this.fullHeroThumbnail,*/
                incomingHeroThumbnail: process.env.MIX_CLOUDFRONT_DNSNAME + JSON.parse(this.content).filename + '/' + process.env.MIX_BASE_THUMBNAIL_KEY  + JSON.parse(this.content).hero_thumbnail + '.jpg',

                heroContentCustomBkg: false,

                changeHeroThumbnail: false,
                changeHeroLightBkg: false,
                changeHeroDarkBkg: false,

                heroThumbnailToUpload: null,
                heroThumbnailFileName: '',
                heroThumbnailPreviewURL: '',

                heroContentSelectedBackground: 0,
                heroContentText: '',

                heroCustomBkgLightToUpload: null,
                heroCustomBkgLightFileName: '',
                heroCustomBkgDarkToUpload: null,
                heroCustomBkgDarkFileName: '',

                heroCustomBkgLightPreviewURL: '',
                heroCustomBkgDarkPreviewURL: '',

                isUploadingThumbnail: false,
                thumbnailUploadProgress: 0,
                hasFinishedUploadingThumbnail: false,

                isUploadingLightBkg: false,
                lightBkgUploadProgress: 0,
                hasFinishedUploadingLightBkg: false,

                isUploadingDarkBkg: false,
                darkBkgUploadProgress: 0,
                hasFinishedUploadingDarkBkg: false,

            }
        },

        props: [
            'content',
            'basecategories',
            'basesubcategories',
            'basetags',
            'basepois',
            'basecountries',
            'incomingcategories',
            'incomingsubcategories',
            'incomingtags',
            'incomingpois',
            'incomingcountries',
            'currentlocale',
            'bkg_urls'
        ],

        computed: {

            mediaBucketName() {
                return process.env.MIX_AWS_MEDIA_BUCKET;
            },

            legacyThumbnailsBucketName() {
                return process.env.MIX_AWS_LEGACY_THUMBNAILS_BUCKET;
            },

            cloudSource() {
                if(this.theContent.legacy) {
                    /*return process.env.MIX_LEGACY_CLOUDFRONT_DNSNAME*/
                    return this.ENV_CloudFront_Legacy_DNS_Name
                } else {
                    /*return process.env.MIX_CLOUDFRONT_DNSNAME*/
                    return this.ENV_CloudFront_DNS_Name
                }
            },

            thumbnailsCloudSource() {
                if(this.theContent.legacy) {
                    /*return process.env.MIX_LEGACY_CLOUDFRONT_DNSNAME*/
                    return this.ENV_CloudFront_LegacyThumbnails_DNS_Name
                } else {
                    /*return process.env.MIX_CLOUDFRONT_DNSNAME*/
                    return this.ENV_CloudFront_DNS_Name
                }
            },

            incomingRenderSize() {
                /*console.log('Incoming render size: ' + JSON.parse(this.content).render_size);*/
                return JSON.parse(this.content).render_size;
            },

            incomingIsHero() {
                return JSON.parse(this.content).is_hero;
            },

            /*heroContentCustomBkg() {
                return JSON.parse(this.content).hero_background === 3
            },*/

            fullHeroThumbnail() {
                return this.ENV_CloudFront_DNS_Name + JSON.parse(this.content).filename + '/' + process.env.MIX_BASE_THUMBNAIL_KEY  + JSON.parse(this.content).hero_thumbnail + '.jpg';
            },

            incomingCustomLightBkg() {
                return this.ENV_CloudFront_DNS_Name + JSON.parse(this.content).filename + '/' + process.env.MIX_BASE_THUMBNAIL_KEY  + JSON.parse(this.content).hero_background_image + '.jpg';
            },

            incomingCustomDarkBkg() {
                return this.ENV_CloudFront_DNS_Name + JSON.parse(this.content).filename + '/' + process.env.MIX_BASE_THUMBNAIL_KEY  + JSON.parse(this.content).hero_background_image_dark + '.jpg';
            },

            incomingMainThumbnail() {
                /*return this.ENV_CloudFront_DNS_Name + JSON.parse(this.content).thumbnail_url;*/
                return JSON.parse(this.content).thumbnail_url;
            },


            thumbnailUploadProgressText() {
                if (this.isUploadingThumbnail) {
                    return this.thumbnailUploadProgress.toString() + '%';
                }

                if (this.hasFinishedUploadingThumbnail) {
                    return this.translate("content-create-upload-short");
                }
                else {
                    if (this.uploadError !== '') {
                        return 'ERROR: ' + this.uploadError;
                    } else {
                        return this.translate("content-create-inactive");
                    }
                }
            },

            mainThumbnailUploadProgressText() {
                if (this.isUploadingMainThumbnail) {
                    return this.mainThumbnailUploadProgress.toString() + '%';
                }

                if (this.hasFinishedUploadingMainThumbnail) {
                    return this.translate("content-create-upload-short");
                }
                else {
                    if (this.uploadError !== '') {
                        return 'ERROR: ' + this.uploadError;
                    } else {
                        return this.translate("content-create-inactive");
                    }
                }
            },

            lightBkgUploadProgressText() {
                if (this.isUploadingLightBkg) {
                    return this.lightBkgUploadProgress.toString() + '%';
                }

                if (this.hasFinishedUploadingLightBkg) {
                    return this.translate("content-create-upload-short");
                }
                else {
                    if (this.uploadError !== '') {
                        return 'ERROR: ' + this.uploadError;
                    } else {
                        return this.translate("content-create-inactive");
                    }
                }
            },

            darkBkgUploadProgressText() {
                if (this.isUploadingDarkBkg) {
                    return this.darkBkgUploadProgress.toString() + '%';
                }

                if (this.hasFinishedUploadingDarkBkg) {
                    return this.translate("content-create-upload-short");
                }
                else {
                    if (this.uploadError !== '') {
                        return 'ERROR: ' + this.uploadError;
                    } else {
                        return this.translate("content-create-inactive");
                    }
                }
            },



            heroContentStyling() {

                let background = '';
                let suffix = this.$root.shared.theme === 'theme-dark' ? '_dark.jpg' : '_light.jpg';

                if(this.heroContentAssignedBkg===3) {
                    if(this.$root.shared.theme==='theme-light') {
                        background = 'url(' + this.ENV_CloudFront_DNS_Name + this.theContent.filename + '/' + this.ENV_Thumbnail_Key + this.theContent.hero_background_image + '.jpg' + ')';
                    } else {
                        background = 'url(' + this.ENV_CloudFront_DNS_Name + this.theContent.filename + '/' + this.ENV_Thumbnail_Key + this.theContent.hero_background_image_dark + '.jpg' + ')';
                    }
                } else {
                    background = 'url(' + JSON.parse(this.bkg_urls)[this.heroContentAssignedBkg] + suffix + ')'
                }

                console.log('Returning as Background URL: ' + background);

                return {
                    'background-size': 'contain',
                    'background-image': background,
                    'background-repeat': 'no-repeat',
                    'max-height': '395px',
                    'max-width': '1400px'
                }

            },



            initialPublishAction() {
                if(moment(JSON.parse(this.content).publish_date) < moment().tz('America/Caracas')) {
                    return 0
                } else {
                    return 1
                }
            },

            incomingCategories() {

                let theCats = JSON.parse(this.incomingcategories);
                let incomingCatArray = []
                theCats.forEach(tag => {
                    incomingCatArray.push(tag.id);
                });

                return incomingCatArray;

            },

            incomingSubCategories() {

                let theSubCats = JSON.parse(this.incomingsubcategories);
                let incomingSubCatArray = []
                theSubCats.forEach(tag => {
                    incomingSubCatArray.push(tag.id);
                });

                return incomingSubCatArray;

            },

            incomingTags() {

                if(this.currentlocale==='es') {
                    return JSON.parse(this.incomingtags).map(tag => { return { text: tag.name } });
                } else {
                    return JSON.parse(this.incomingtags).map(tag => { return { text: tag.name_en } });
                }


            },

            selectedPoiArray() {
                return JSON.parse(this.incomingpois).map(poi => { return { id: poi.id, label: poi.name, correspondent: poi.is_valid_correspondent } });
            },


            selectedCountriesArray() {
                if(this.currentlocale==='es') {
                    return JSON.parse(this.incomingcountries).map(country => {
                        return {id: country.id, label: country.name}
                    });
                } else {
                    return JSON.parse(this.incomingcountries).map(country => {
                        return {id: country.id, label: country.name_en}
                    });
                }
            },


            contentPiece() {

                return JSON.parse(this.content);

            },

            autocompleteItems() {

                let tmp = [];

                JSON.parse(this.basetags).forEach(data => {
                    tmp.push({'text': data.name});
                })

                return tmp;

            },

            autocompleteItems_en() {

                let tmp = [];

                JSON.parse(this.basetags).forEach(data => {
                    tmp.push({'text': data.name_en});
                })

                return tmp;

            },

            filteredItems() {

                if(this.currentlocale==='es') {
                    return this.autocompleteItems.filter(i => {
                        return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
                    });
                } else {
                    return this.autocompleteItems_en.filter(i => {
                        return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
                    });
                }

                /*return this.autocompleteItems.filter(i => {
                    return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
                });*/
            },

            personsList() {
                return JSON.parse(this.basepois).map(person => { return { label: person.name, id: person.id, correspondent: person.is_valid_correspondent } });
            },

            countriesList() {

                if(this.currentlocale==='es') {
                    return JSON.parse(this.basecountries).map(country => {
                        return {label: country.name, id: country.id}
                    });
                } else {
                    return JSON.parse(this.basecountries).map(country => {
                        return {label: country.name_en, id: country.id}
                    });
                }
            },

            readyToPublish() {

                if(this.theContent.legacy) {

                    if (this.theContent.title === '') return false;
                    if (this.theContent.abstract === '') return false;
                    if (this.scheduledPublishingDate === '') return false;
                    if (this.contentVisibility === null) return false;
                    if (this.contentRestrictions === null) return false;
                    if (this.renderSize === '') return false;

                    if (this.changeMainThumbnail) {
                        if (!this.hasFinishedUploadingMainThumbnail) return false;
                    }

                    if (this.isHeroContent) {

                        if (this.changeHeroThumbnail) {
                            if (!this.hasFinishedUploadingThumbnail) return false;
                        }

                        if (this.heroContentAssignedBkg===3) {

                            if (this.changeHeroLightBkg) {
                                if (!this.hasFinishedUploadingLightBkg) return false;
                            }
                            if (this.changeHeroDarkBkg) {
                                if (!this.hasFinishedUploadingDarkBkg) return false;
                            }

                            if (this.heroCustomBkgLightFileName === '') return false;
                            if (this.heroCustomBkgDarkFileName === '') return false;
                        }

                    }

                    // If we reach here, it means all data is present and we
                    // can proceed on!

                    return true;

                } else {

                    if (this.theContent.title === '') return false;
                    if (this.theContent.abstract === '') return false;
                    if (this.checkIfArrayEmpty(this.newSelectedCategories)) return false;
                    if (this.checkIfArrayEmpty(this.newSelectedSubCategories)) return false;
                    if (this.publishActionId === null) return false;
                    if (this.scheduledPublishingDate === '') return false;
                    if (this.contentVisibility === null) return false;
                    if (this.contentRestrictions === null) return false;
                    if (this.renderSize === '') return false;

                    if (this.changeMainThumbnail) {
                        if (!this.hasFinishedUploadingMainThumbnail) return false;
                    }

                    if (this.isHeroContent) {

                        if (this.changeHeroThumbnail) {
                            if (!this.hasFinishedUploadingThumbnail) return false;
                        }

                        if (this.heroContentAssignedBkg===3) {

                            if (this.changeHeroLightBkg) {
                                if (!this.hasFinishedUploadingLightBkg) return false;
                            }
                            if (this.changeHeroDarkBkg) {
                                if (!this.hasFinishedUploadingDarkBkg) return false;
                            }

                            if (this.heroCustomBkgLightFileName === '') return false;
                            if (this.heroCustomBkgDarkFileName === '') return false;
                        }

                    }

                    // If we reach here, it means all data is present and we
                    // can proceed on!

                    return true;
                }
            },

        },

        methods: {

            /**
             * Request a presigned URL from the backend for S3 upload
             */
            async getPresignedUrl(filename, contentType, bucket = 'upload', key = null, metadata = {}) {
                try {
                    const response = await axios.post('/api/s3/presigned-url', {
                        filename: filename,
                        content_type: contentType,
                        bucket: bucket,
                        key: key || filename,
                        metadata: metadata
                    });
                    return response.data;
                } catch (error) {
                    console.error('Error getting presigned URL:', error);
                    throw error;
                }
            },

            /**
             * Upload file to S3 using presigned URL with progress tracking
             */
            uploadToPresignedUrl(presignedData, file, onProgress, onComplete, onError) {
                const xhr = new XMLHttpRequest();

                // Track upload progress
                xhr.upload.addEventListener('progress', (event) => {
                    if (event.lengthComputable) {
                        const percentComplete = parseInt((event.loaded * 100) / event.total);
                        onProgress(percentComplete);
                    }
                });

                // Handle completion
                xhr.addEventListener('load', () => {
                    if (xhr.status === 200) {
                        onComplete(xhr.response);
                    } else {
                        onError(new Error(`Upload failed with status ${xhr.status}`));
                    }
                });

                // Handle errors
                xhr.addEventListener('error', () => {
                    onError(new Error('Upload failed'));
                });

                xhr.addEventListener('abort', () => {
                    onError(new Error('Upload aborted'));
                });

                // Open and send the request
                xhr.open('PUT', presignedData.url);
                xhr.setRequestHeader('Content-Type', presignedData.headers['Content-Type']);
                xhr.send(file);

                return xhr;
            },

            processHeroThumbnail(files) {

                this.isEditing = true;
                this.hasFinishedUploadingThumbnail = false;

                let file = files[0];

                this.heroThumbnailToUpload = file;
                console.log(JSON.stringify(this.heroThumbnailToUpload.name));
                /*this.heroThumbnailFileName = this.theContent.filename + '_hero_thumbnail';*/
                this.heroThumbnailFileName = 'telesur-video-' + moment().tz('America/Caracas').format('YYYY-MM-DD-HHmmssSSSSSS') + '_hero_thumbnail';
                this.heroThumbnailPreviewURL = URL.createObjectURL(file);

            },

            processMainThumbnail(files) {

                this.isEditing = true;
                this.hasFinishedUploadingMainThumbnail = false;

                let file = files[0];

                this.mainThumbnailToUpload = file;
                console.log(JSON.stringify(this.mainThumbnailToUpload.name));
                /*this.heroThumbnailFileName = this.theContent.filename + '_hero_thumbnail';*/
                this.mainThumbnailFileName = 'telesur-video-' + moment().tz('America/Caracas').format('YYYY-MM-DD-HHmmssSSSSSS') + '.0000001';
                this.mainThumbnailPreviewURL = URL.createObjectURL(file);

            },

            processHeroCustomLightBkg(files) {

                this.isEditing = true;
                this.hasFinishedUploadingLightBkg = false;

                let file = files[0];

                this.heroCustomBkgLightToUpload = file;
                /*this.heroCustomBkgLightFileName = this.theContent.filename + '_custom_bkg_light';*/
                this.heroCustomBkgLightFileName = 'telesur-video-' + moment().tz('America/Caracas').format('YYYY-MM-DD-HHmmssSSSSSS') + '_custom_bkg_light';
                this.heroCustomBkgLightPreviewURL = URL.createObjectURL(file);

            },

            processHeroCustomDarkBkg(files) {

                this.isEditing = true;
                this.hasFinishedUploadingDarkBkg = false;

                let file = files[0];

                this.heroCustomBkgDarkToUpload = file;
                /*this.heroCustomBkgDarkFileName = this.theContent.filename + '_custom_bkg_dark';*/
                this.heroCustomBkgDarkFileName = 'telesur-video-' + moment().tz('America/Caracas').format('YYYY-MM-DD-HHmmssSSSSSS') + '_custom_bkg_dark';
                this.heroCustomBkgDarkPreviewURL = URL.createObjectURL(file);

            },


            async uploadThumbnail() {

                let file = this.heroThumbnailToUpload;
                let newFileName = this.theContent.filename + '/' + process.env.MIX_BASE_THUMBNAIL_KEY + this.heroThumbnailFileName + '.jpg';

                console.log('UPLOADING THUMBNAIL NAMED: ' + newFileName + ', from file picked as: ' + file.name);

                this.isUploadingThumbnail = true;
                this.thumbnailUploadProgress = 0;
                this.hasFinishedUploadingThumbnail = false;

                try {
                    const presignedData = await this.getPresignedUrl(
                        newFileName,
                        file.type,
                        'media',
                        newFileName
                    );

                    this.uploadToPresignedUrl(
                        presignedData,
                        file,
                        (progress) => {
                            this.thumbnailUploadProgress = progress;
                        },
                        () => {
                            this.isUploadingThumbnail = false;
                            this.hasFinishedUploadingThumbnail = true;
                            this.incomingHeroThumbnail = this.heroThumbnailPreviewURL;
                            this.changeHeroThumbnail = true;
                        },
                        (err) => {
                            console.log('ERROR: ', err);
                            this.isUploadingThumbnail = false;
                            this.hasFinishedUploadingThumbnail = false;
                            this.uploadError = err.message;
                        }
                    );

                } catch (error) {
                    console.log('ERROR getting presigned URL: ', error);
                    this.isUploadingThumbnail = false;
                    this.hasFinishedUploadingThumbnail = false;
                    this.uploadError = error.message;
                }
            },

            async uploadMainThumbnail() {

                let file = this.mainThumbnailToUpload;
                let newFileName, bucket;

                if(this.theContent.legacy) {
                    newFileName = this.mainThumbnailFileName + '.jpg';
                    bucket = 'media'; // Legacy thumbnails also use media bucket
                } else {
                    newFileName = this.theContent.filename + '/' + process.env.MIX_BASE_THUMBNAIL_KEY + this.mainThumbnailFileName + '.jpg';
                    bucket = 'media';
                }

                console.log('UPLOADING THUMBNAIL NAMED: ' + newFileName + ', from file picked as: ' + file.name);

                this.isUploadingMainThumbnail = true;
                this.mainThumbnailUploadProgress = 0;
                this.hasFinishedUploadingMainThumbnail = false;

                try {
                    const presignedData = await this.getPresignedUrl(
                        newFileName,
                        file.type,
                        bucket,
                        newFileName
                    );

                    this.uploadToPresignedUrl(
                        presignedData,
                        file,
                        (progress) => {
                            this.mainThumbnailUploadProgress = progress;
                        },
                        () => {
                            this.isUploadingMainThumbnail = false;
                            this.hasFinishedUploadingMainThumbnail = true;
                            this.changeMainThumbnail = true;
                        },
                        (err) => {
                            console.log('ERROR: ', err);
                            this.isUploadingMainThumbnail = false;
                            this.hasFinishedUploadingMainThumbnail = false;
                            this.uploadError = err.message;
                        }
                    );

                } catch (error) {
                    console.log('ERROR getting presigned URL: ', error);
                    this.isUploadingMainThumbnail = false;
                    this.hasFinishedUploadingMainThumbnail = false;
                    this.uploadError = error.message;
                }

            },


            async uploadLightBkg() {

                let file = this.heroCustomBkgLightToUpload;
                let newFileName = this.theContent.filename + '/' + process.env.MIX_BASE_THUMBNAIL_KEY + this.heroCustomBkgLightFileName + '.jpg';

                console.log('UPLOADING CUSTOM BKG NAMED: ' + newFileName + ', from file picked as: ' + file.name);

                this.isUploadingLightBkg = true;
                this.lightBkgUploadProgress = 0;
                this.hasFinishedUploadingLightBkg = false;

                try {
                    const presignedData = await this.getPresignedUrl(
                        newFileName,
                        file.type,
                        'media',
                        newFileName
                    );

                    this.uploadToPresignedUrl(
                        presignedData,
                        file,
                        (progress) => {
                            this.lightBkgUploadProgress = progress;
                        },
                        () => {
                            this.isUploadingLightBkg = false;
                            this.hasFinishedUploadingLightBkg = true;
                            this.changeHeroLightBkg = true;
                        },
                        (err) => {
                            console.log('ERROR: ', err);
                            this.isUploadingLightBkg = false;
                            this.hasFinishedUploadingLightBkg = false;
                            this.uploadError = err.message;
                        }
                    );

                } catch (error) {
                    console.log('ERROR getting presigned URL: ', error);
                    this.isUploadingLightBkg = false;
                    this.hasFinishedUploadingLightBkg = false;
                    this.uploadError = error.message;
                }
            },

            async uploadDarkBkg() {

                let file = this.heroCustomBkgDarkToUpload;
                let newFileName = this.theContent.filename + '/' + process.env.MIX_BASE_THUMBNAIL_KEY + this.heroCustomBkgDarkFileName + '.jpg';

                console.log('UPLOADING CUSTOM BKG NAMED: ' + newFileName + ', from file picked as: ' + file.name);

                this.isUploadingDarkBkg = true;
                this.darkBkgUploadProgress = 0;
                this.hasFinishedUploadingDarkBkg = false;

                try {
                    const presignedData = await this.getPresignedUrl(
                        newFileName,
                        file.type,
                        'media',
                        newFileName
                    );

                    this.uploadToPresignedUrl(
                        presignedData,
                        file,
                        (progress) => {
                            this.darkBkgUploadProgress = progress;
                        },
                        () => {
                            this.isUploadingDarkBkg = false;
                            this.hasFinishedUploadingDarkBkg = true;
                            this.changeHeroDarkBkg = true;
                        },
                        (err) => {
                            console.log('ERROR: ', err);
                            this.isUploadingDarkBkg = false;
                            this.hasFinishedUploadingDarkBkg = false;
                            this.uploadError = err.message;
                        }
                    );

                } catch (error) {
                    console.log('ERROR getting presigned URL: ', error);
                    this.isUploadingDarkBkg = false;
                    this.hasFinishedUploadingDarkBkg = false;
                    this.uploadError = error.message;
                }
            },








            translate(key) {
                key = 'strings.' + key;
                return lang.get(key);
            },

            setInitialVisibilityIndex() {

                switch (this.theContent.visibility) {
                    case 'Público' || 'Public':
                        this.visibilityIndex = 1;
                        break;
                    case 'Privado' || 'Private':
                        this.visibilityIndex = 2;
                        break;
                    case 'No Listado' || 'Unlisted':
                        this.visibilityIndex = 3;
                        break;
                    default:
                        this.visibilityIndex = 1;
                }

            },

            setInitialRestrictionsIndex() {

                switch (this.theContent.restrictions) {
                    case 'Abierto' || 'Open':
                        this.restrictionsIndex = 1;
                        break;
                    case 'Con Credenciales' || 'With Credentials':
                        this.restrictionsIndex = 2;
                        break;
                    case 'Sin Descargas' || 'Restricted':
                        this.restrictionsIndex = 3;
                        break;
                    default:
                        this.restrictionsIndex = 1;
                }

            },

            updateVisibility() {
                this.isEditing=true;
                this.visibilityIndex = this.contentVisibility.id;
                /*console.log('Current Visibility: ' + this.visibilityIndex);*/
            },

            updateRestrictions() {
                this.isEditing=true;
                this.restrictionsIndex = this.contentRestrictions.id;
                /*console.log('Current Restrictions: ' + this.restrictionsIndex);*/
            },

            tagEditing(obj) {
                this.isEditing = true;
                obj.deleteTag();
            },

            checkForAreaChanges() {
                if(this.theContent.abstract !== this.initialAreaText) {
                    this.isEditing = true;
                }
            },

            personSelected(value) {
                /*console.log('You selected something in the Persons dropdown: ' + JSON.stringify(value));*/
                this.isEditing = true;
                this.newSelectedPoiArray.push(value);
            },

            countrySelected(value) {
                /*console.log('You selected something in the Countries dropdown: ' + JSON.stringify(value));*/
                this.isEditing = true;
                this.newSelectedCountryArray.push(value);
            },

            removePoiFromSelectedList(index) {
                this.isEditing = true;
                this.newSelectedPoiArray.splice(index, 1)
            },

            removeCountryFromSelectedList(index) {
                this.isEditing = true;
                this.newSelectedCountryArray.splice(index, 1)
            },

            publishHasChanged(value) {
                /*console.log('Changed to Action: ' + this.publishActionId['id'])*/
                this.displayDateTimePicker = value['id'] !== 0;
                this.updatePublishDate();
            },

            updatePublishDate() {

                this.isEditing = true;

                /*console.log('Incoming Action: ' + this.publishActionId['id']);*/

                /*if(this.publishActionId.id === 0) {*/
                if(this.publishActionId['id'] === 0) {
                    this.scheduledPublishingDate = moment().tz('America/Caracas').format('YYYY-MM-DD HH:mm').split(' ')[0];
                    this.scheduledPublishingTime = moment().tz('America/Caracas').format('YYYY-MM-DD HH:mm').split(' ')[1];
                    /*console.log('Selected Action: De Inmediato =>' + this.publishActionId['id'])*/
                } else {
                    this.scheduledPublishingDate = this.pickedPublishingDate ? moment(this.pickedPublishingDate).format('YYYY-MM-DD') : moment(this.scheduledPublishingDate).format('YYYY-MM-DD');
                    this.scheduledPublishingTime = moment(this.pickedPublishingTime).tz('America/Caracas').format('HH:mm');
                    /*console.log('Selected Action: Agendar => ' + this.publishActionId['id'])*/
                }

            },

            toggleTimePicker() {

                this.timePickerVisible = !this.timePickerVisible;

            },

            showTimePicker() {

                this.timePickerVisible = true;

            },

            hideTimePicker() {

                this.timePickerVisible = false;

            },

            handleTimePicked(event) {

                this.scheduledPublishingTime = this.simpleStringValue;

            },

            checkIfArrayEmpty(array) {
                return !(Array.isArray(array) && array.length);
            },

            cancelEditing() {
                if (this.isEditing) {
                    if (!confirm(this.translate("content-create-abandon-confirm"))) {
                        return;
                    }
                }
                if(this.theContent.legacy) {
                    window.location = '/' + this.currentlocale  + '/admin/content/legacy'
                } else {
                    window.location = '/' + this.currentlocale  + '/admin/content'
                }
            },


            updateContent() {

                /*console.log('Sending data to backend...');*/

                this.isUpdating = true;

                let thumbnailURL = '';

                if (this.changeMainThumbnail) {
                    thumbnailURL = this.theContent.legacy ? this.mainThumbnailFileName + '.jpg' : this.theContent.filename + '/' + this.ENV_Thumbnail_Key + this.mainThumbnailFileName + '.jpg';
                } else {
                    thumbnailURL = this.mainThumbnailFileName;
                }

                this.contentPayload = {

                    id: this.theContent.id,
                    filename: this.theContent.filename,
                    original_filename: this.theContent.original_filename,
                    storage_url: this.theContent.storage_url,
                    /*thumbnail_url: this.theContent.thumbnail_url,*/
                    /*thumbnail_url: this.theContent.filename + '/' + process.env.MIX_BASE_THUMBNAIL_KEY + this.mainThumbnailFileName + '.jpg',*/
                    thumbnail_url: thumbnailURL,
                    title: this.theContent.title,
                    abstract: this.theContent.abstract,
                    correspondent_id: this.assignedCorrespondent,
                    categories: this.newSelectedCategories,
                    subcategories: this.newSelectedSubCategories,
                    tags: this.newSelectedTags,
                    pois: this.newSelectedPoiArray,
                    countries: this.newSelectedCountryArray,
                    publish_date: this.scheduledPublishingDate + ' ' + this.scheduledPublishingTime,
                    upload_date: this.theContent.uploadDate,
                    render_size: this.renderSize,
                    visibility: this.visibilityIndex,
                    restrictions: this.restrictionsIndex,
                    media_duration: this.theContent.media_duration,
                    legacy: this.theContent.legacy,

                    is_hero: this.isHeroContent,
                    hero_thumbnail: this.heroThumbnailFileName,
                    hero_background: this.heroContentAssignedBkg,

                    hero_text: this.heroContentText,
                    hero_background_image: this.heroCustomBkgLightFileName,
                    hero_background_image_dark: this.heroCustomBkgDarkFileName

                }

                    axios.post('/' + this.currentlocale + '/admin/content/update', this.contentPayload)
                        .then((response) => {
                            /*console.log('Server Response: ' + response);*/
                            this.isEditing = false;
                            this.isStoring = false;

                            this.processMessage();

                        })
                        .catch((error) => {
                            this.storingProducedErrors = true;
                            this.isEditing = false;
                            this.isStoring = false;

                            this.flashMessage.error({
                                    title: 'Ha ocurrido un Error!',
                                    message: 'Mensaje: ' + error,
                                    time: 5000
                            });
                        });
            },

            processMessage() {

                setTimeout(() => {
                    this.flashMessage.success({
                            title: this.translate("content-edit-edited"),
                            message: this.translate("content-edit-success"),
                            blockClass: 'p-6',
                            time: 3000
                        },
                        {
                            destroyed: this.returnBack
                        });
                },  500)

            },

            returnBack() {
                window.location=document.referrer
            },

            getServerDateTime() {

                axios.get('/api/serverdatetime')
                    .then(response => {
                        console.log(response.data.hours + ':' + response.data.minutes + ':' + response.data.seconds);
                        this.serverDateTime = response.data.hours + ':' + response.data.minutes + ':' + response.data.seconds;
                        return response.data.hours + ':' + response.data.minutes + ':' + response.data.seconds;
                    }).catch(e => {
                    console.log('Error getting Date Time from Server! E: ' + e);
                })

            },

            heroContentSelected() {

                this.isEditing = true;
                this.heroContentSectionVisible = !this.heroContentSectionVisible;

            }


        },

        created() {

            this.getServerDateTime();

            this.theContent = this.contentPiece;

            this.heroContentCustomBkg = (JSON.parse(this.content).hero_background === 3);

            this.newSelectedTags = this.incomingTags;
            this.newSelectedCategories = this.incomingCategories;
            this.newSelectedSubCategories = this.incomingSubCategories;
            this.newSelectedPoiArray = this.selectedPoiArray;
            this.newSelectedCountryArray = this.selectedCountriesArray;

            this.initialAreaText = this.theContent.abstract;
            this.renderSize = this.theContent.render_size;

            this.mainThumbnailFileName = this.theContent.thumbnail_url;
            this.mainThumbnailPreviewURL = this.incomingMainThumbnail;

            if(this.theContent.hero_thumbnail) {
                this.heroThumbnailPreviewURL = this.incomingHeroThumbnail;
                this.heroThumbnailFileName = JSON.parse(this.content).hero_thumbnail;
            } else {
                this.heroThumbnailPreviewURL = '';
            }

            if(this.theContent.hero_background_image) {
                this.heroCustomBkgLightPreviewURL = this.incomingCustomLightBkg;
                this.heroCustomBkgLightFileName = JSON.parse(this.content).hero_background_image;
            } else {
                this.heroCustomBkgLightPreviewURL = '';
            }

            if(this.theContent.hero_background_image_dark) {
                this.heroCustomBkgDarkPreviewURL = this.incomingCustomDarkBkg;
                this.heroCustomBkgDarkFileName = JSON.parse(this.content).hero_background_image_dark;
            } else {
                this.heroCustomBkgDarkPreviewURL = '';
            }

            if(this.theContent.hero_text) {
                this.heroContentText = this.theContent.hero_text;
            } else {
                this.heroContentText = '';
            }

            this.setInitialVisibilityIndex();
            this.setInitialRestrictionsIndex();

            /*console.log('Initial Visibility: ' + this.visibilityIndex);
            console.log('Initial Restrictions: ' + this.restrictionsIndex);*/
        }

    }

</script>



<style lang="scss">

    /* VUE TAGS STYLING  */

    .vue-tags-input {
        max-width: 800px !important;
    }

    .tags-input {

        width: 100%;
        max-width: none;

        .ti-input {
            border: none;
            border-bottom: 1px solid var(--bg-level-3);
            padding: 4px 12px;
        }
        .ti-tag input {
            color: var(--control-label);
        }
        .ti-tag, .ti-item.ti-selected-item {
            border-radius: 4px;
            background-color: var(--controls-3);
            color: var(--control-label);
        }
        .ti-tags li {
            padding: 5px 8px;
            margin:2px;
        }
        .ti-tag.dark-font {
            color: var(--txt-title);
        }
        .ti-item {
            padding: 2px 3px;
        }
        .ti-tag.ti-deletion-mark  {
            @apply bg-red-600;
            /* background-color: red !important; */
            color: var(--control-label);
        }
    }

    .ti-autocomplete {
        max-height: 160px;
        overflow: scroll;
    }

    /* SELECT DROPDOWN STYLES */

    .vs__dropdown-toggle {
        font-size: 12px;
        border: 1px solid var(--bg-level-2) !important;
    }

    .vs__selected {
        color: var(--txt-main);
    }

</style>

<style scoped>

    .desktop-hs > li,
    .desktop-item {
        scroll-snap-align: center;
        /*padding: calc(var(--gutter) / 2 * 1.5);*/
        display: flex;
        flex-direction: column;
        justify-content: start;
        /*align-items: center;*/
        background: #fff;
        border-radius: 8px;
        overflow: hidden;
        max-height: 280px;
        min-height: 280px;
    }

    .desktop-hs > li,
    .desktop-large-item {
        scroll-snap-align: center;
        /*padding: calc(var(--gutter) / 2 * 1.5);*/
        display: flex;
        flex-direction: column;
        justify-content: start;
        /*align-items: center;*/
        background: #fff;
        border-radius: 8px;
        overflow: hidden;
        max-height: 580px;
    }

    .icon-circled {
        background-color: var(--txt-copy-5);
    }

    .icon-circled:hover {
        background-color: var(--txt-copy-6);
        fill: var(--txt-main);
    }

    .inline-svg-icon {
        fill: var(--txt-discrete);
    }

    .inline-svg-icon:hover {
        fill: var(--txt-main);
    }

    .local-hover-trigger .local-hover-target-secondary {
        visibility: hidden;
        opacity: 0;
        height: 0rem;
    }

    .local-hover-trigger:hover .local-hover-target-secondary {
        visibility: visible;
        opacity: 1;
        height: 4rem;
    }

    .local-hover-trigger .local-hover-target {
        visibility: hidden;
        opacity: 0;
    }

    .local-hover-trigger:hover .local-hover-target {
        visibility: visible;
        opacity: 1;
    }

</style>
